
<style scoped>
.header {
  font-size: 14px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  padding-bottom: 20px;
  color:#1aa197;
}
.list .item {
  display: flex;
  border-bottom: 1px solid #f8f8f8;
  line-height: 36px;
}
.list .item .left,
.list .item .right {
  flex: 1;
  display: flex;
}
.list .item .left .title,
.list .item .right .title {
  width: 220px !important;
  font-weight: bold;
}
.list .item .left .content,
.list .item .right .content {
  color: #666;
  flex: 1;
}
.box {
  max-height: 70vh;  /* 调整为更合理的高度 */
  overflow-y: auto;
  padding-right: 10px;
}
/* 滚动条样式优化 */
.box::-webkit-scrollbar {
  width: 6px;
}
.box::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
.box::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}
/* 当edition为3时的特殊样式 */
.edition-combined {
  padding-bottom: 20px;
}
</style>
<template>
  <a-modal
    title="详情"
    :visible="visible"
    @cancel="cancel"
    :width="1000"
    :footer="null"
    :bodyStyle="{ maxHeight: '80vh', overflow: 'hidden' }"
  >
    <div class="box" :class="{'edition-combined': data && data.edition === 3}">
      <div class="header">
        <span>基本信息</span>
      </div>
      <div class="base" v-if="data != null">
        <!-- 基本信息 -->
        <baseInfo :data="data" />
      </div>
      <!-- 简版-->
      <div>
          <div class="header" style="margin-top: 20px">
            <span>语言</span>
          </div>
          <div class="list">
            <div class="item">
              <div class="left">
                <div class="title">语言-表达性沟通(EC):</div>
                <div class="content">{{ data.score_ec }}</div>
              </div>
              <div class="right">
                <div class="title">语言-接受性沟通(RC):</div>
                <div class="content">{{ data.score_rc }}</div>
              </div>
            </div>
          
            <div class="item">
              <div class="left">
                <div class="title">显著性水平:</div>
                <div class="content">{{ data.significance_level }}</div>
              </div>
              <div class="right">
                <div class="title">置信区间:</div>
                <div class="content">{{ data.confidence_probability }}%</div>
              </div>
            </div>
          </div>
          <div class="header" style="margin-top: 20px">
            <span>行为观察清单</span>
          </div>
          <div class="list">
            <div class="item">
              <div class="left">
                <div class="title">主试</div>
              </div>
              <div class="right">
                <div class="title">照护者</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="title">积极影响:</div>
                <div class="content" v-if="data.observation_ex1 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex1 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex1 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">积极影响:</div>
                <div class="content" v-if="data.observation_tk1 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk1 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk1 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>
            <div class="item">
              <div class="left">
                <div class="title">热情:</div>
                <div class="content" v-if="data.observation_ex2 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex2 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex2 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">热情:</div>
                <div class="content" v-if="data.observation_tk2 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk2 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk2 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">探索:</div>
                <div class="content" v-if="data.observation_ex3 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex3 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex3 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">探索:</div>
                <div class="content" v-if="data.observation_tk3 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk3 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk3 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">容易投入:</div>
                <div class="content" v-if="data.observation_ex4 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex4 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex4 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">容易投入:</div>
                <div class="content" v-if="data.observation_tk4 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk4 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk4 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">合作性:</div>
                <div class="content" v-if="data.observation_ex5 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex5 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex5 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">合作性:</div>
                <div class="content" v-if="data.observation_tk5 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk5 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk5 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">适度活跃:</div>
                <div class="content" v-if="data.observation_ex6 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex6 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex6 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">适度活跃:</div>
                <div class="content" v-if="data.observation_tk6 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk6 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk6 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">对改变的适应性:</div>
                <div class="content" v-if="data.observation_ex7 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex7 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex7 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">对改变的适应性:</div>
                <div class="content" v-if="data.observation_tk7 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk7 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk7 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">警觉性:</div>
                <div class="content" v-if="data.observation_ex8 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex8 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex8 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">警觉性:</div>
                <div class="content" v-if="data.observation_tk8 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk8 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk8 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">注意力分散:</div>
                <div class="content" v-if="data.observation_ex9 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex9 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex9 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">注意力分散:</div>
                <div class="content" v-if="data.observation_tk9 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk9 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk9 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">动作张力:</div>
                <div class="content" v-if="data.observation_ex10 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex10 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex10 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">动作张力:</div>
                <div class="content" v-if="data.observation_tk10 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk10 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk10 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">触觉防御:</div>
                <div class="content" v-if="data.observation_ex11 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex11 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex11 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">触觉防御:</div>
                <div class="content" v-if="data.observation_tk11 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk11 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk11 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">恐惧/焦虑:</div>
                <div class="content" v-if="data.observation_ex12 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex12 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex12 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">恐惧/焦虑:</div>
                <div class="content" v-if="data.observation_tk12 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk12 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk12 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

            <div class="item">
              <div class="left">
                <div class="title">消极影响:</div>
                <div class="content" v-if="data.observation_ex13 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_ex13 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_ex13 === '3'">完全不典型；从不或很少如此</div>
              </div>
              <div class="right">
                <div class="title">消极影响:</div>
                <div class="content" v-if="data.observation_tk13 === '1'">非常典型；总是如此</div>
                <div class="content" v-if="data.observation_tk13 === '2'">有点典型；有时如此</div>
                <div class="content" v-if="data.observation_tk13 === '3'">完全不典型；从不或很少如此</div>
              </div>
            </div>

          </div>
        </div>
      <!-- 完整版-->
      <div v-if="data.edition == 1 || data.edition == 3">
        <div class="header" style="margin-top: 20px">
          <span>社会-情绪和适应行为	</span>
        </div>
        <div class="list">
          <div class="item">
            <div class="left">
              <div class="title">社会-情绪(SE):</div>
              <div class="content">{{ data.score_se }}</div>
            </div>
            <div class="right">
              <div class="title">适应行为-接受性(REC):</div>
              <div class="content">{{ data.score_rec }}</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">适应行为-表达性(EXP):</div>
              <div class="content">{{ data.score_exp }}</div>
            </div>
            <div class="right">
              <div class="title">个人自理(PER):</div>
              <div class="content">{{ data.score_per }}</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">人际关系(IPR):</div>
              <div class="content">{{ data.score_ipr }}</div>
            </div>
            <div class="right">
              <div class="title">玩耍与休闲(PLA):</div>
              <div class="content">{{ data.score_pla }}</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">显著性水平:</div>
              <div class="content">{{ data.significance_level }}</div>
            </div>
            <div class="right">
              <div class="title">置信区间:</div>
              <div class="content">{{ data.confidence_probability }}%</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">最高掌握阶段:</div>
              <div class="content">
                <span v-if="data.highest_stage === '1'">还未掌握第一阶段</span>
                <span v-if="data.highest_stage === '2'">第1阶段</span>
                <span v-if="data.highest_stage === '3'">第2阶段</span>
                <span v-if="data.highest_stage === '4'">第3阶段</span>
                <span v-if="data.highest_stage === '5'">第4(a)阶段</span>
                <span v-if="data.highest_stage === '6'">第4(b)阶段</span>
                <span v-if="data.highest_stage === '7'">第5(a)阶段</span>
                <span v-if="data.highest_stage === '8'">第5(b)阶段</span>
                <span v-if="data.highest_stage === '9'">第6阶段</span>
              </div>
            </div>
          </div>
        </div>
        <div class="header" style="margin-top: 20px">
          <span>社会-情绪	</span>
        </div>
        <div class="list">
          <div class="item">
            <div class="left">
              <div class="title">第1-8题原始总分:</div>
              <div class="content">{{ data.score_original }}</div>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="title">无法判断/猜测的题目数量:</div>
              <div class="content">{{ data.guess_se }}</div>
            </div>
          </div>
        </div>
        <div class="header" style="margin-top: 20px">
          <span>适应行为	</span>
        </div>
        <div class="list">
          <div class="item">
            <div class="left">
              <div class="title">接受性(REC)猜测总题数:</div>
              <div class="content">{{ data.guess_rec }}</div>
            </div>
            <div class="right">
              <div class="title">接受性(REC)施测总题数:</div>
              <div class="content">{{ data.guess_rec_total }}</div>
            </div>
          </div>

          <div class="item">
            <div class="left">
              <div class="title">表达性(EXP)猜测总题数:</div>
              <div class="content">{{ data.guess_exp }}</div>
            </div>
            <div class="right">
              <div class="title">表达性(EXP)施测总题数:</div>
              <div class="content">{{ data.guess_exp_total }}</div>
            </div>
          </div>

          <div class="item">
            <div class="left">
              <div class="title">个人自理(PER)猜测总题数:</div>
              <div class="content">{{ data.guess_per }}</div>
            </div>
            <div class="right">
              <div class="title">个人自理(PER)施测总题数:</div>
              <div class="content">{{ data.guess_per_total }}</div>
            </div>
          </div>

          <div class="item">
            <div class="left">
              <div class="title">人际关系(IPR)猜测总题数:</div>
              <div class="content">{{ data.guess_ipr }}</div>
            </div>
            <div class="right">
              <div class="title">人际关系(IPR)施测总题数:</div>
              <div class="content">{{ data.guess_ipr_total }}</div>
            </div>
          </div>

          <div class="item">
            <div class="left">
              <div class="title">玩耍与休闲(PLA)猜测总题数:</div>
              <div class="content">{{ data.guess_pla }}</div>
            </div>
            <div class="right">
              <div class="title">玩耍与休闲(PLA)施测总题数:</div>
              <div class="content">{{ data.guess_pla_total }}</div>
            </div>
          </div>

          </div>
        </div>
        <div v-if="hasDetailScores">
          <div class="header" style="margin-top: 20px">
            <span>详细题目分数</span>
          </div>
          <bayley-score-detail :value="detailScores" readonly />
        </div>
        
      </div>
    </div>
  </a-modal>
</template>

<script>
import { Detail } from "../../commonApi";
import BayleyScoreDetail from "../bayley-score-detail";
export default {
  components: { BayleyScoreDetail },
  props: {
    item: [Object],
    detailVisible: [Boolean],
  },
  watch: {
    item: {
      handler: function (e) {
        this.data = e;
        this.id = e.id;
        if (e.edition == 1) {
          this.title = "2:6 - 3:11";
        } else if (e.edition == 2) {
          this.title = "4:0 - 6:11";
        }
      },
      immediate: true,
      deep: true,
    },
    detailVisible: {
      handler: function (e) {
        this.visible = e;
        if (this.visible) {
          this.getDetail();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    detailScores() {
      const scores = this.data && this.data.detail_scores;
      if (scores && typeof scores === "object") return scores;
      if (typeof scores === "string" && scores) {
        try {
          return JSON.parse(scores);
        } catch (e) {
          return {};
        }
      }
      return {};
    },
    hasDetailScores() {
      return (
        this.data &&
        String(this.data.detail_score_enabled) === "1" &&
        Object.keys(this.detailScores).length > 0
      );
    },
  },
  data() {
    return {
      title: "",
      visible: true,
      id: "",
      data: null,
      type: "",
    };
  },
  created() {},
  methods: {
    async getDetail() {
      const res = await Detail({ id: this.id });
      if (res && res.code == 0) {
        this.data = res.bayleyAssessment;
      }
    },
    cancel() {
      this.visible = false;
      this.$emit("detailCancel");
    },
  },
};
</script>
